import { Process } from "../models/eaf.models";

export const validateTimeField = (
  value: Date | null,
  fieldName: string,
  process: Process | undefined,
): string | true => {
  if (!value) return true;

  const timeValue = new Date(value);

  switch (fieldName) {
    case "StartHeat":
      if (process?.Start && timeValue < new Date(process.Start)) {
        return "Start Heat time must be after Start";
      }
      if (process?.StartTap && timeValue > new Date(process.StartTap)) {
        return "Start Heat time must be before Start Tap";
      }
      if (process?.End && timeValue >= new Date(process.End)) {
        return "Start Heat time must be before End";
      }
      break;

    case "StartTap":
      const startTime = process?.StartHeat ? new Date(process.StartHeat) : null;
      const endTime = process?.End ? new Date(process.End) : null;

      if (startTime && timeValue < startTime) {
        return "Start Tap must be after Start Heat";
      }

      if (endTime && timeValue > endTime) {
        return "Start Tap must be before End";
      }
      break;

    case "End":
      if (process?.StartHeat && timeValue <= new Date(process.StartHeat)) {
        return "End time must be after Start Heat";
      }
      if (process?.StartTap && timeValue < new Date(process.StartTap)) {
        return "End time must be after Start Tap";
      }
      break;
  }

  return true;
};
